
    // IMPORTS
    import { computed, defineComponent, PropType, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import router from '@/router';
    import { buildLocalization, navigateToFallbackRoute } from '@/util'

    import NavigationBar from '@/components/navigation-bar.vue'
    import PortalNotification from './portal-notification.vue'
    import SiteTitle from './site-title.vue'
    import TopBannerToolbar from './top-banner-toolbar.vue'

    import { INavigationItem } from '@/types/INavigationItem'
    import { useBrowserStateStore } from '@/store/browserState';

    export default defineComponent({
        name: 'topBanner',

        components: {
            NavigationBar,
            PortalNotification,
            SiteTitle,
            TopBannerToolbar
        },

        props: {
            title: { type: String as PropType<string | null>, required: false, default: () => null },
            showBackButton: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            showLogOff: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            navigationItems: { type: Array as PropType<INavigationItem[]>, required: false, default: () => [] }
        },

        setup(props, { slots }) {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const route = useRoute()
            const { localize } = buildLocalization()
            const browserState = useBrowserStateStore()

            const logoffMenuItem = {
                textName: 'LogOff',
                routeName: 'logoff'
            } as INavigationItem      
            
            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const dbName = ref<string | null>(null)
            const publicData = { dbName }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const effectiveNavigationItems = computed(() => browserState.isSmallScreen && props.showLogOff
                ? [...props.navigationItems, logoffMenuItem]
                : props.navigationItems
            )

            const isSmallScreen = computed(() => browserState.isSmallScreen)
            const renderCustomNavigationSlot = computed(() => !!slots.navigation)

            const computedData = {
                effectiveNavigationItems,
                isSmallScreen,
                renderCustomNavigationSlot
            }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            function goBack() {
                if (window.history.state?.back) {
                    router.go(-1)
                } else {
                    navigateToFallbackRoute(router, route)
                }
            }

            const publicMethods = { localize, goBack }
            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
